import React from "react";
import "./Welcome.sass";

export default function Welcome() {
  return (
    <div className="welcome">
      <div className="welcome-bg">
        <div className="welcome-container">
          <h1>
            Welcome <br className="break-mobile" /> to the Halls of Amenti{" "}
          </h1>
          <h2>
            All Frens are made in Kek’s image and therefore Blessed with Eternal
            Gains. However, the Halls of Amenti may only be entered by the Sons
            of Amenti. Those Enlightened with Kek’s magical GIF powers.
          </h2>
          <h3>
            The FreDAO is Entrusted to Maintain the Order and Natural Law in the
            world Kek has fashioned for the Frens.
          </h3>
        </div>
        <div className="welcome-break"></div>
      </div>
    </div>
  );
}
